var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5323 13.6458C18.3188 13.6458 18.114 13.7306 17.963 13.8816C17.812 14.0326 17.7272 14.2374 17.7272 14.451V16.0613C17.7272 16.7019 17.4727 17.3163 17.0197 17.7693C16.5667 18.2222 15.9523 18.4767 15.3117 18.4767H13.7014C13.4879 18.4767 13.2831 18.5616 13.1321 18.7126C12.9811 18.8635 12.8962 19.0683 12.8962 19.2819C12.8962 19.4954 12.9811 19.7002 13.1321 19.8512C13.2831 20.0022 13.4879 20.087 13.7014 20.087H15.3117C16.379 20.0858 17.4022 19.6612 18.1569 18.9065C18.9116 18.1518 19.3362 17.1286 19.3375 16.0613V14.451C19.3375 14.2374 19.2526 14.0326 19.1016 13.8816C18.9506 13.7306 18.7459 13.6458 18.5323 13.6458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.818703 7.20447C1.03224 7.20447 1.23704 7.11964 1.38803 6.96865C1.53903 6.81765 1.62386 6.61286 1.62386 6.39932V4.78901C1.62386 4.14839 1.87834 3.53401 2.33133 3.08102C2.78431 2.62804 3.3987 2.37355 4.03932 2.37355H5.64962C5.86316 2.37355 6.06796 2.28872 6.21895 2.13773C6.36995 1.98673 6.45477 1.78194 6.45477 1.5684C6.45477 1.35486 6.36995 1.15006 6.21895 0.999069C6.06796 0.848073 5.86316 0.763245 5.64962 0.763245H4.03932C2.97201 0.764523 1.94878 1.18908 1.19408 1.94378C0.439381 2.69848 0.0148283 3.7217 0.0135498 4.78901L0.0135498 6.39932C0.0135498 6.61286 0.0983782 6.81765 0.249374 6.96865C0.400369 7.11964 0.605163 7.20447 0.818703 7.20447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64938 18.4767H4.03907C3.39845 18.4767 2.78407 18.2222 2.33108 17.7693C1.8781 17.3163 1.62361 16.7019 1.62361 16.0613V14.451C1.62361 14.2374 1.53878 14.0326 1.38779 13.8816C1.23679 13.7306 1.032 13.6458 0.818459 13.6458C0.604919 13.6458 0.400125 13.7306 0.24913 13.8816C0.0981341 14.0326 0.0133057 14.2374 0.0133057 14.451L0.0133057 16.0613C0.0145841 17.1286 0.439137 18.1518 1.19384 18.9065C1.94854 19.6612 2.97176 20.0858 4.03907 20.087H5.64938C5.86292 20.087 6.06771 20.0022 6.21871 19.8512C6.3697 19.7002 6.45453 19.4954 6.45453 19.2819C6.45453 19.0683 6.3697 18.8635 6.21871 18.7126C6.06771 18.5616 5.86292 18.4767 5.64938 18.4767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3117 0.763245H13.7014C13.4879 0.763245 13.2831 0.848073 13.1321 0.999069C12.9811 1.15006 12.8962 1.35486 12.8962 1.5684C12.8962 1.78194 12.9811 1.98673 13.1321 2.13773C13.2831 2.28872 13.4879 2.37355 13.7014 2.37355H15.3117C15.9523 2.37355 16.5667 2.62804 17.0197 3.08102C17.4727 3.53401 17.7272 4.14839 17.7272 4.78901V6.39932C17.7272 6.61286 17.812 6.81765 17.963 6.96865C18.114 7.11964 18.3188 7.20447 18.5323 7.20447C18.7459 7.20447 18.9506 7.11964 19.1016 6.96865C19.2526 6.81765 19.3375 6.61286 19.3375 6.39932V4.78901C19.3362 3.7217 18.9116 2.69848 18.1569 1.94378C17.4022 1.18908 16.379 0.764523 15.3117 0.763245V0.763245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.18164,
    y: 10.9935,
    width: 4.92483,
    height: 4.92483,
    rx: 1.15942,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.18091,
    y: 4.93048,
    width: 4.92483,
    height: 4.92483,
    rx: 1.15942,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6077,
    y: 11.9709,
    width: 2.70487,
    height: 2.70487,
    rx: 1.35243,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6228,
    y: 4.93115,
    width: 4.92483,
    height: 4.92483,
    rx: 1.15942,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3237,
    height: 19.3237,
    fill: "white",
    transform: "translate(0.0135498 0.763245)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainQr);
export default __webpack_public_path__ + "static/media/main_qr.ee1aceda97c5976e914efd2750b6209d.svg";
export { ForwardRef as ReactComponent };